import { useCallback } from 'react';
import { useSoftphoneCallState } from '..';
import { getMergedStream } from '../../../utils/stream-utils';
import { useSoftphoneAudio } from '../../softphone-audio-provider';
import { useSoftphoneEventsEmitter } from '../../softphone-events-provider';
import { SoftphoneCallActionsContextValue } from '../softphone-call-actions.provider';
import { useToggleHold } from './use-hold-call';
import { useReInvite } from './use-reinvite';

/**
 *
 * Triggers the acceptance of an incoming call, but does not update any state.
 * State updates and other side effects are handled by the handleCallAnswered delegate
 */
export const useMergeCalls = (): SoftphoneCallActionsContextValue['mergeCalls'] => {
  const { emit } = useSoftphoneEventsEmitter();
  const { toggleHoldAll } = useToggleHold();
  const stream = useSoftphoneAudio((ctx) => ctx.stream);
  const setMergedCallIds = useSoftphoneCallState((ctx) => ctx.setMergedCallIds);
  const calls = useSoftphoneCallState((ctx) => ctx.calls);
  const { reInviteCalls } = useReInvite();

  return useCallback(
    async (calls: any) => {
      const sessions = calls.map((call: any) => call.session);
      /* toggleHoldAll needs to be before getMergedStream for the sender/reciever tracks to be enabled first */
      await toggleHoldAll(false);
      const mediaStream = getMergedStream(sessions);
      stream('remote', mediaStream);
      setMergedCallIds(calls.map((call: any) => call.id));
      emit('conference-call.merged', calls);
      return calls;
    },
    [calls, reInviteCalls, toggleHoldAll]
  );
};
